import React, { Component } from 'react';
import { observer } from 'mobx-react';
import KarteStore from '../../store';
import styled from 'styled-components';

import divide1 from '../../images/divide-icon@2x.png';
import divide2 from '../../images/divide-icon2@2x.png';
import divide3 from '../../images/divide-icon3@2x.png';
import divide4 from '../../images/divide-icon4@2x.png';

type Props = {
  karteStore: KarteStore;
};

@observer
class DivisionDrawer extends Component<Props> {
  render() {
    const { karteStore } = this.props;
    return (
      <Wrapper>
        <Ul>
          <Li>
            <DivideButton onClick={karteStore.changeDivision.bind(this, 1)}>
              <DivideImg src={divide1} />
              <p>全画面</p>
            </DivideButton>
          </Li>
          <Li>
            <DivideButton onClick={karteStore.changeDivision.bind(this, 2)}>
              <DivideImg src={divide2} />
              <p>2分割</p>
            </DivideButton>
          </Li>
          <Li>
            <DivideButton onClick={karteStore.changeDivision.bind(this, 3)}>
              <DivideImg src={divide3} />
              <p>3分割</p>
            </DivideButton>
          </Li>
          <Li>
            <DivideButton onClick={karteStore.changeDivision.bind(this, 4)}>
              <DivideImg src={divide4} />
              <p>4分割</p>
            </DivideButton>
          </Li>
        </Ul>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div``;

const Ul = styled.ul`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  background: #fff;
  justify-content: center;
  align-items: center;
`;

const Li = styled.li`
  padding: 10px;
`;

const DivideImg = styled.img`
  width: 50%;
`;

const DivideButton = styled.button`
  cursor: pointer;
  outline: none;
  background: #fff;
  border: none;
`;

export default DivisionDrawer;
